import React from 'react';
import PropTypes from 'prop-types';
import { WithManagedFocuser } from '@bingads-webui-react/hoc-with-managed-focuser';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import './month-calender.less';

class MonthItemInternal extends React.PureComponent {
  onFocusHandler = () => {
    this.props.focusItemCallback(this.props.monthIdx);
  }

  handleMonthSelect = () => {
    const {
      onSelectMonth,
      monthIdx,
      year,
      isMonthRangePicker,
      month,
    } = this.props;
    if (isMonthRangePicker && !month.isInBounds) {
      return;
    }

    onSelectMonth(monthIdx, year);
  }

  render() {
    const {
      monthIdx,
      formatMonth,
      i18n,
      focusableRef,
      focusThis,
      monthClass,
    } = this.props;

    return (
      <td
        key={monthIdx}
        ref={focusableRef}
        role="gridcell"
        tabIndex={monthIdx === 0 ? '0' : '-1'}
        className={`monthItem-${formatMonth(monthIdx, i18n)} ${monthClass}`}
        onKeyDown={event => submitEvent(this.handleMonthSelect)({ keyCode: event.which })}
        onClick={focusThis && this.handleMonthSelect}
        onFocus={this.onFocusHandler}
      >
        <div
          className="day"
          role="gridcell"
        >
          <span aria-hidden="true">{formatMonth(monthIdx, i18n)}</span>
        </div>
      </td>
    );
  }
}

MonthItemInternal.propTypes = {
  monthIdx: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  formatMonth: PropTypes.func.isRequired,
  onSelectMonth: PropTypes.func.isRequired,
  focusThis: PropTypes.func.isRequired,
  focusItemCallback: PropTypes.func.isRequired,
  focusableRef: PropTypes.func,
  monthClass: PropTypes.string,
  isMonthRangePicker: PropTypes.bool,
  month: PropTypes.shape({}),
};

MonthItemInternal.defaultProps = {
  focusableRef: null,
  monthClass: '',
  isMonthRangePicker: false,
  month: {},
};


export const MonthItem = WithManagedFocuser(MonthItemInternal);
